"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetOfferExtraPricesDetailsWebModel = createGetOfferExtraPricesDetailsWebModel;
exports.fetchGetOfferExtraPricesDetailsWeb = fetchGetOfferExtraPricesDetailsWeb;
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

function createGetOfferExtraPricesDetailsWebModel(parameters) {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'newbuilding-promos',
    pathApi: '/v1/get-offer-extra-prices-details-web/',
    response: {
      200: {
        contentType: 'json'
      },
      400: {
        contentType: 'json'
      }
    },
    request: {
      parameters
    }
  };
}
async function fetchGetOfferExtraPricesDetailsWeb(_ref) {
  let {
    httpApi,
    config,
    mappers,
    parameters
  } = _ref;
  const {
    statusCode,
    response,
    headers
  } = await httpApi.fetch(createGetOfferExtraPricesDetailsWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response, headers);
    }
  }
  return {
    statusCode,
    response,
    headers
  };
}